import styled from 'styled-components'

export const UserAddress = styled.span`
  color: ${props => props.theme.linkColor};
`
